export type AutomaticDownloadMode = {
  automaticDownloadModeId: string;
  name: string;
  sortOrder: number;
  active: number;
  rowVersion: string;
};

// country
export type Country = {
  name: string;
  id?: string;
  description: string;
  rowVersion?: string;
};

export type Device = {
  deviceId: string;
  name: string;
  wildXRNumber: string;
  installationId: string;
  organizationId: string;
  rowVersion: string;
};

export const MapMarkerIcons = [
  {
    label: "Bone",
    value: 0,
  },
  {
    label: "Butterfly",
    value: 1,
  },
  {
    label: "Cactus",
    value: 2,
  },
  {
    label: "Fin",
    value: 3,
  },
  {
    label: "FootPrint",
    value: 4,
  },
  {
    label: "Frog",
    value: 5,
  },
  {
    label: "Leaf",
    value: 6,
  },
  {
    label: "Lizard",
    value: 7,
  },
  {
    label: "Magnifying Glass",
    value: 8,
  },
  {
    label: "Mountain",
    value: 9,
  },
  {
    label: "Palm Tree",
    value: 10,
  },
  {
    label: "Paw",
    value: 11,
  },
  {
    label: "Question Mark",
    value: 12,
  },
  {
    label: "Snowflake",
    value: 13,
  },
  {
    label: "Wave",
    value: 15,
  },
  {
    label: "Wing",
    value: 16,
  },
];

export type Installation = {
  installationId: string;
  name: string;
  videoCatalogueId: string;
  forceOfflineMode: boolean;
  showGraphicDeath: boolean;
  showGraphicSex: boolean;
  controls: string;
  demoMode: boolean;
  globeStartLat: number;
  globeStartLong: number;
  appTimerLengthSeconds: number;
  idleTimerLengthSeconds: number;
  idleTimerDelaySeconds: number;
  startupVideoId?: string;
  resumeStartupVideoOnAwake: boolean;
  rowVersion?: string;
  startupVideoLoop: boolean;
  showMenuTray: boolean;
  tips: string;
  favorites: { videoId: string }[];
  filterFavoritesByDefault: boolean;
  tutorialMode: string;
  tutorialText: string;
  organizationId: string;
  automaticDownloadModeID: string;
  shouldSendSessionData: boolean;
};

// iucn status
export type IUCNStatus = {
  name: string;
  id: string;
  description: string;
  rowVersion?: string;
};

// population trend
export type PopulationTrend = {
  name: string;
  id: string;
  description: string;
  rowVersion?: string;
};

// species
export type Species = {
  name: string;
  speciesId: string | null;
  colloquialName?: string;
  scientificName?: string;
  description?: string;
  populationTrendId: string;
  iucnStatusId: string;
  speciesCategoryId: string;
  rowVersion?: string;
};
// species category
export type SpeciesCategory = {
  name: string;
  description?: string;
  id: string;
  rowVersion?: string;
};
// organizations
export type Organization = {
  name: string;
  organizationId: string;
  rowVersion?: string;
};

export type MapMarker = {
  mapMarkerId: string;
  name: string;
  description: string;
  latitude: number;
  longitude: number;
  iconID: number;
  rowVersion?: string;
  organizationId: string;
  videos: Video[] | null;
  location?: string;
};

export type Tag = {
  tagId: string;
  name: string;
  description?: string;
  rowVersion?: string;
};

export type TimeSpan = {
  hours: number;
  minutes: number;
  seconds: number;
};
// new video
export type Video = {
  videoId: string | null;
  thumbnailUrl: string;
  name: string;
  dateCreated: string;
  lastEditedBy: string | null;
  lastEditedDate: string | null;
  overview: string;
  countryObtainedId: string; // id of country
  species: Species[] | null;
  tags: Tag[] | null;
  mapMarkers: MapMarker[] | null;
  rowVersion: string;
  streamingUrl: string;
  downloadUrl: string;
  totalViews: number;
  totalLikes: number;
  totalDislikes: number;
  rating: string;
  youTubeUrl: string;
  startTime: string;
  endTime: string;
  showInAllVideos: boolean;
  compilation: boolean;
  gameDrive: boolean;
  graphicSex: boolean;
  graphicDeath: boolean;
  videoFormat: string;
  videoStatusId: number;
  videoResolutionId: string;
  organizationId: string | null;
  videoFileName: string;
};

export type UploadStatus = {
  message: string;
  uploadStatusId: number;
};

export type VideoCataloguesDto = {
  videoCatalogueId: string;
  name: string;
  description: string;
  siteId: string;
  organizationId: string;
  lastEditedBy: string;
  lastEditedDate: string;
  videos: Video[];
  mapMarkers: MapMarker[];
};

export type VideoFormatDto = {
  videoFormatId: string;
  name: string;
  sortOrder: number;
  active: boolean;
  rowVersion: string;
};

export type VideoStatusDto = {
  videoStatusId: string;
  name: string;
  sortOrder: number;
  rowVersion: string;
};

export type VideoResolutionDto = {
  videoResolutionId: string;
  name: string;
  sortOrder: number;
  rowVersion: string;
};

export type UploadResponse = {
  success: boolean;
  message: string;
};

export type User = {
  userId: string;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  isSystemAdmin: boolean;
  isHeadsetAdmin: boolean;
  organizations: Organization[];
  roles: Role[];
  password?: string;
};

export type Role = {
  roleId: string;
  name: string;
  rowVersion?: string;
};
